export default __webpack_public_path__ + "static/Dekra_LP2_Screen-89ca9af31905b8f202d6159b07e62df4.png";